<template>
    <div id="app">
        <emt-header></emt-header>
        <emt-menu-bar v-if="login"></emt-menu-bar>
        <main class="container-fluid">
            <router-view></router-view>
        </main>
        <emt-footer></emt-footer>
    </div>
</template>

<script>
import EmtHeader from '@/components/emt-header'
import EmtMenuBar from '@/components/emt-menu-bar'
import EmtFooter from '@/components/emt-footer'
import Cookies from 'js-cookie'

export default {
    name: 'app',
    data: function () {
        return {
            login: false
        }
    },
    components: {
        'emt-header': EmtHeader,
        'emt-menu-bar': EmtMenuBar,
        'emt-footer': EmtFooter
    },
    methods: {
        showMenuBar: function () {
            this.login = true
        },
        hideMenuBar: function () {
            this.login = false
        }
    },
    created: function () {
        if (Cookies.get('token')) {
            this.login = true
        }
    }
}
</script>
<style>
.year-month-wrapper {
    background-color: white !important;
}
.month, .year{
    text-align: center !important;
    color: #777777 !important;
    width: 77px !important;
    font-weight: 500 !important;
}
.nav-l:hover, .nav-r:hover {
    background-color: #ffffff;
}
.nav-l, .nav-r {
    background-color: #ffffff !important;
    color: #000000 !important;
    font-weight: 600;
}
.port, .days {
    width: 34px !important;
}
.days {
    color: #000000 !important;
}
.activePort, .activePort:hover {
    background-color: #a0a0a0 !important;
}
.port[data-v-76dde8c0]:hover {
    color: #007934 !important;
}
.okButton {
    color: #007934 !important;
}
li.active[data-v-76dde8c0] {
    background-color: #a0a0a0 !important;
}
</style>




// WEBPACK FOOTER //
// App.vue?03b9ba84